/*
 * @Author: huangzq
 * @Date: 2020-04-07 22:39:08
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-07-08 15:07:13
 * @Desc: 添加资料、商品公用弹窗-mk-drawer-biz-two已改，没问题了
*/
<template>
  <div class="materials-goods-dialog">
    <mk-drawer-biz-two
      :visible="visible"
      :append-to-body="false"
      :modal-append-to-body="false"
      :title="title"
      size="820px"
      confirm-text="添 加"
      @open="handelOnDrawerOpen"
      @close="handelOnDrawerClose"
      @cancel="handelOnDrawerClose"
      @confirm="handelOnDrawerConfirm"
    >
      <list-biz
        v-if="visible"
        v-loading="listBizLoading"
        :config="config"
        :data="listData"
        :total="total"
        :page="params.page"
        :select-radio="section"
        @on-type-change="handleOnTypeChange"
        @on-search-change="hanldeOnSearchClick"
        @on-reset-change="hanldeOnResetClick"
        @on-current-change="handleOnCurrentChange"
        @on-select-change="handleOnSelectChange"
      />
    </mk-drawer-biz-two>
  </div>
</template>

<script>
import MkDrawerBizTwo from '@components/mk-drawer-biz-two'

import componentMap from '../config/componentMap'

export default {
  name: 'MaterialsGoodsDialog',
  components: { MkDrawerBizTwo },
  props: {
    // 是否显示资料选择弹窗
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'materials'
    }
  },
  data () {
    return {
      listBizLoading: true,
      // 当前被选中的资料id
      section: '',
      // 当前组件对应的数据
      config: {},
      // 对应资料的列表数据
      listData: [],
      // 对应资料的数据总数
      total: 0,
      // 接口参数数据
      params: {
        page: 1,
        pageSize: 10,
        showTags: true,
        tags: [],
        title: '',
        // v1.0.5.4 普通素材改为企业文件夹
        fileTypes: [],
        // category: '',
        status: 1 // 已发布
      },
      // 所有组件数据
      componentMap
    }
  },
  methods: {
    // 弹窗打开事件
    handelOnDrawerOpen () {
      this.config = this._.cloneDeep(this.componentMap[this.type])

      if (this.type === 'goods') {
        this.config.form.input.placeholder = '请输入商品名称'
      }
      this.hanldeOnResetClick()
    },

    // 根据类型获取对应的接口api
    ajaxMap (type) {
      const map = {
        'article': BIZAPIS.MaterialArticleApi.materialArticleIndexPost,
        'h5': MKMATERIALSVC.H5Api.h5ListPost,
        'form': BIZAPIS.FormApi.materialFormIndexPost,
        'poster': MKMATERIALSVC.PosterApi.posterPost,
        'brochure': MKMATERIALSVC.BrochureApi.brochureListPost,
        'case': MKMATERIALSVC.CaseApi.caseFindListPartPost,
        'video': MKMATERIALSVC.OrdinaryApi.ordinaryListWithFiletypePost,
        'good': MKMATERIALSVC.GoodApi.goodFindListPost
      }
      return map[type]
    },

    // 获取页面数据
    async getListBizData (func, params, load) {
      this.listBizLoading = true

      const type = this.config.params.type
      // 额外参数
      const otherParams = {}
      // 当为视频时，要额外加个参数name
      if (type === 'video') otherParams.name = params.title

      // 这里进行数据处理
      const { success, data: { data, list, total, count }, msg } = await func({
        ...params,
        ...otherParams
      })

      if (success) {
        // 无限加载与翻页事件
        let currentList = this.transformMap(data || list)
        if (load) {
          if (!(currentList.length < this.params.pageSize)) {
            this.params.page++
            this.listData = this.listData.concat(currentList)
          }
        } else {
          this.listData = currentList
          this.total = total || count
        }
      } else {
        this.$message.error(msg)
      }

      this.$nextTick(() => {
        this.listBizLoading = false
      })
    },

    // 处理普通素材的数据：因为普通素材没有cover、title、releaseTime等，所以需要将其他的转为符合的字段
    transformMap (listData) {
      let list = []
      listData.forEach(item => {
        if (item.url) {
          item.cover = item.url
        }
        if (item.name) {
          const type = this.config.params.type
          if (type !== 'form') item.title = item.name
        }
        if (item.id) {
          item._id = item.id
        }
        // 商品封面图处理
        if (item.carouselPicture && item.carouselPicture.length > 0) {
          item.cover = item.carouselPicture[0].url || ''
        }
        list.push(item)
      })
      return list
    },

    // 类型切换事件
    handleOnTypeChange (type) {
      this.config.params.type = type
      this.params.page = 1
      if (type === 'video') {
        this.params.fileTypes = [8]
        this.params.name = ''
      } else {
        this.params.fileTypes = []
        this.params.name = ''
      }
      this.getListBizData(this.ajaxMap(type), this.params)
    },

    // 搜索按钮点击事件
    hanldeOnSearchClick (params) {
      this.params = {
        ...this.params,
        ...params,
        page: 1
      }
      // 当为商品时，使用name进行搜索
      if (this.type === 'goods') {
        this.params.name = this.params.title
      } else {
        delete this.params.name
      }
      // 这里还要区分下类型
      this.getListBizData(this.ajaxMap(this.config.params.type), this.params)
    },

    // 重置按钮事件
    hanldeOnResetClick () {
      this.params = {
        page: 1,
        pageSize: 10,
        showTags: true,
        tags: [],
        title: '',
        fileTypes: [],
        status: 1 // 已发布
      }
      // 这里还要区分下类型
      this.getListBizData(this.ajaxMap(this.config.params.type), this.params)
    },

    // 表格选中事件
    handleOnSelectChange (section) {
      this.section = section
    },

    // 翻页事件
    handleOnCurrentChange (value) {
      this.params.page = value
      this.getListBizData(this.ajaxMap(this.config.params.type), this.params, false)
    },

    // 弹窗关闭事件
    handelOnDrawerClose () {
      this.section = ''
      this.$emit('update:visible', false)
    },

    // 弹窗确认事件
    handelOnDrawerConfirm () {
      if (this.section) {
        const _id = this.section
        const { type } = this.config.params
        const findItem = this.listData.find(item => item._id === _id)

        const params = { _id, type, item: findItem }

        this.$emit('on-confirm', params)
      } else {
        this.$message.error('请先选择资料')
      }
    }

  }
}
</script>
